import { createFileRoute, Link } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RecordColumn } from "@/components/common/record"
import { Button } from "@/components/ui/button"
import { FirmAddresses } from "@/features/firms/components/firm-addresses"
import { countryQueries } from "@/queries/countries"
import { firmRecordQueries } from "@/queries/firm-record"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/"
)({
  staticData: { attention: "firm.addresses" },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(
        firmRecordQueries.addresses(params.firmId)
      ),
      context.queryClient.ensureQueryData(countryQueries.list()),
    ])
  },
  component: FirmAddressesPage,
})

function FirmAddressesPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Addresses"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/firms/$firmId/addresses/edit"
                params={{ firmId }}
              >
                Update addresses
              </Link>
            }
          />
        }
      />

      <RecordColumn className="max-w-4xl">
        <FirmAddresses firmId={firmId} />
      </RecordColumn>
    </>
  )
}
